/**
 * Converts the hero slice's saved locations into the options the Hero slice's
 * location dropdown expects. Each option value is the map boundary query
 * string, which the listings search reads as `geo-*` params.
 */
export const buildLocationSelectOptions = options => {
  if (!Array.isArray(options)) return [];

  return options
    .filter(option => option?.name && option?.query_string)
    .map(option => ({ label: option.name, value: option.query_string }));
};
